import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseVendorViewComponent } from 'msp/shared/base-vendor-view/base-vendor-view.component';
import { WorkerTypeSub, WorkerVMSTypeSub } from 'shared/models/static-list-data.service';
import { AppStateService } from 'shared/services/app-state.service';


@Component({
  selector: 'app-worker-type-sub-lookup',
  templateUrl: './worker-type-sub-lookup.component.html',
  styleUrls: ['./worker-type-sub-lookup.component.css']
})
export class WorkerTypeSubLookupComponent extends BaseVendorViewComponent implements OnInit {

  
  @Input() placeholder = 'Worker Type Sub';
  @Input() set resetData(isClear) {
      this.onClear(isClear);
  }
  @Output() selectedValue: EventEmitter<any> = new EventEmitter<any>();
  workerTypeSubList: any = [];
  selectedWorkerTypeSub: any = [];
  accessType;
  constructor(private _appStateService: AppStateService) { 
    super(_appStateService);    
  }

  ngOnInit() {
    this.accessType = this._appStateService.getAccessType(); 
    this.workerTypeSubList =(this.accessType === 'vendor' || this.viewAsVendor) ? WorkerVMSTypeSub : WorkerTypeSub;
       const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';       
       setTimeout(() => {
         if ((preselected && preselected['workerTypeSub'])) {
           this.selectedWorkerTypeSub = preselected['workerTypeSub'];
         } else {
        //   const analiticsPage = localStorage.getItem('filterObj_anaylitics') ? JSON.parse(localStorage.getItem('filterObj_anaylitics')) : '';
        //    if ((analiticsPage && analiticsPage['workerTypeSub'])) {
        //      this.selectedWorkerTypeSub = analiticsPage['workerTypeSub'];
        //    }
          } 
                  
      },100);
  }
  onChange() {
    this.selectedValue.emit(this.selectedWorkerTypeSub);
  }

  onClear(isClear) {
      this.selectedWorkerTypeSub = [];
      if (isClear) {
          this.selectedValue.emit([]);
      }
  }

}
